import { Link } from "react-router-dom";
import modusLogo from "../Modus_logo.png";

export default function SiteFooter() {
  return (
    <footer>
      <div className="wrap">
        <div className="foot-grid">
          <div>
            <div className="foot-logo">
              <span className="foot-logo-badge">
                <img src={modusLogo} alt="Modus" />
              </span>
            </div>
            <p className="foot-tag">
              Thoughtful Care Brokerage. The AI Provider Lookup Tool with the score built in.
            </p>
          </div>
          <div className="foot-col">
            <h3>Platform</h3>
            <Link to="/platform#scoring">Provider Rating</Link>
            <Link to="/platform#red-flag">AI Red Flag</Link>
            <Link to="/platform#call-verification">Call Verification</Link>
            <Link to="/platform#team-notes">Team Notes</Link>
            <Link to="/platform#agentic-layer">Agentic Layer</Link>
            <Link to="/platform#npd">NPD Integration</Link>
          </div>
          <div className="foot-col">
            <h3>Who We Help</h3>
            <Link to="/who-we-help#workers-comp">WC &amp; Group Health</Link>
            <Link to="/who-we-help#credentialing">Credentialing &amp; Care Nav</Link>
            <Link to="/who-we-help#ime">IME Companies</Link>
            <Link to="/who-we-help#tpas">TPAs</Link>
          </div>
          <div className="foot-col">
            <h3>Company</h3>
            <Link to="/why-modus">Why Modus</Link>
            <Link to="/about">About &amp; Leadership</Link>
            <Link to="/resources">Resources</Link>
          </div>
          <div className="foot-col">
            <h3>Get Started</h3>
            <Link to="/about#contact">Book a Demo</Link>
            <a href="https://pdm.modus.org" target="_blank" rel="noopener noreferrer">
              Login
            </a>
          </div>
        </div>
        <div className="foot-bottom">
          <span>© 2026 Modus. Thoughtful Care Brokerage.</span>
          <span>Independent. No hospital or insurer affiliation.</span>
          <span className="foot-legal">
            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/disclaimer">Disclaimer</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}